<div class="dialog">
  <div class="dialog__header">
    <div>
      <h2 class="dialog__title">{{ shift.driverName }} — Shift #{{ shift.shiftId }}</h2>
      <p class="dialog__subtitle">
        {{ shift.regionName }}
        <ng-container *ngIf="shift.timezone"> · {{ shift.timezone }}</ng-container>
      </p>
    </div>
    <button mat-icon-button (click)="close()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog__verdict-row">
    <div>
      <span class="dialog__label">Driver eligible at close</span>
      <lohi-eligibility-status-chip [eligible]="shift.driverEligibleAtClose" size="sm"></lohi-eligibility-status-chip>
    </div>
    <div>
      <span class="dialog__label">Floor top-up</span>
      <span class="dialog__pill" [class.dialog__pill--applied]="shift.floorApplied">
        <ng-container *ngIf="shift.floorApplied; else floorNotApplied">Applied</ng-container>
        <ng-template #floorNotApplied>
          {{ shift.floorEvaluated ? 'Not applied' : 'Not evaluated' }}
        </ng-template>
      </span>
    </div>
  </div>

  <div class="dialog__times">
    <div>
      <span class="dialog__label">Shift start</span>
      <span>{{ shift.shiftStart | date: 'medium' }}</span>
    </div>
    <div *ngIf="shift.shiftEnd">
      <span class="dialog__label">Shift end</span>
      <span>{{ shift.shiftEnd | date: 'medium' }}</span>
    </div>
    <div>
      <span class="dialog__label">Eligibility week</span>
      <span>{{ shift.eligibilityWeekStart }}</span>
    </div>
  </div>

  <div class="dialog__rules">
    <h3>Rule check</h3>
    <lohi-rule-result-row
      *ngFor="let key of ruleKeys; trackBy: trackByRuleKey"
      [ruleKey]="key"
      [result]="ruleFor(key)"
    ></lohi-rule-result-row>
  </div>
</div>
